import { useSlideshow } from '../../../hooks/useSlideshow';

const slides = [
  {
    image:
      '/image/recruit-hero1.png',
    alt: '採用メッセージ',
  },
  {
    image:
      '/image/recruit-hero2.png',
    alt: 'チームミーティング',
  },
  {
    image:
      '/image/recruit-hero3.png',
    alt: 'オフィスワーク',
  },
];

const RecruitHero = () => {
  const { currentSlide, setCurrentSlide } = useSlideshow(slides.length, 3000);

  return (
    <section className="relative w-full h-[500px] md:h-[600px] lg:h-[700px] overflow-hidden" id="recruit-top">
      {slides.map((slide, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-all duration-[1500ms] ${
            i === currentSlide ? 'opacity-100 scale-100' : 'opacity-0 scale-105'
          }`}
        >
          <img
            src={slide.image}
            alt={slide.alt}
            className="w-full h-full object-cover object-center"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      {/* Hero text with staggered entrance animation */}
      <div className="absolute inset-0 flex flex-col justify-start pt-32 md:pt-40">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 w-full">
          <h1 className="text-3xl md:text-4xl lg:text-6xl font-bold text-white leading-tight mb-10 anim-hero-text anim-hero-text-d2">
            理想の未来は<br />
            <span className="inline-block ml-[1em]">ここで叶えよう。</span>
          </h1>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 anim-hero-text anim-hero-text-d4">
            <a
              href="#entry-form"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#89B56B] text-white text-sm font-bold rounded-md hover:bg-[#5DAA68] transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:scale-105 hover:shadow-xl"
            >
              エントリーする
            </a>
            <a
              href="#requirements"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white border-2 border-[#89B56B] text-[#89B56B] text-sm font-bold rounded-md hover:bg-[#89B56B] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105"
            >
              募集要項を見る
            </a>
          </div>
        </div>
      </div>

      {/* Slide indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-3">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrentSlide(i)}
            className={`h-1 rounded-full transition-all duration-500 cursor-pointer ${
              i === currentSlide ? 'w-8 bg-white' : 'w-4 bg-white/40'
            }`}
            aria-label={`スライド ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default RecruitHero;
